import React from 'react'

function Service7() {
    return (
        <div>
            Hello goa
        </div>
    )
}

export default Service7
